import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IInitialState {
  rackId?: string;
}
const initialState: IInitialState = {
  rackId: undefined,
};

const binSlice = createSlice({
  name: 'bin',
  initialState,
  reducers: {
    setRackId(state, action: PayloadAction<IInitialState>) {
      console.log(
        'action.payload.rackId',
        action.payload.rackId,
        action.payload
      );
      state.rackId = action.payload.rackId;
    },
    reset: () => initialState,
  },
});

export const binActions = binSlice.actions;
export default binSlice.reducer;
